import {
  DELETE_RESTAURANT_SUB_CATEGORY_FAILURE,
  DELETE_RESTAURANT_SUB_CATEGORY_REQUEST,
  DELETE_RESTAURANT_SUB_CATEGORY_SUCCESS,
  GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_FAILURE,
  GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST,
  GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_SUCCESS,
  POST_RESTAURANT_SUB_CATEGORY_FAILURE,
  POST_RESTAURANT_SUB_CATEGORY_REQUEST,
  POST_RESTAURANT_SUB_CATEGORY_SUCCESS,
  PUT_RESTAURANT_SUB_CATEGORY_FAILURE,
  PUT_RESTAURANT_SUB_CATEGORY_REQUEST,
  PUT_RESTAURANT_SUB_CATEGORY_SUCCESS,
} from "../../../Utils/Constant";

// Get All Reservation List Details
export const getAllRestaurantSubCategoryListRequest = (payload) => {
  return {
    type: GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST,
    payload,
  };
};

export const getAllRestaurantSubCategoryListSuccess = (data) => {
  return {
    type: GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_SUCCESS,
    payload: data,
  };
};

export const getAllRestaurantSubCategoryListFailure = (error) => {
  return {
    type: GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_FAILURE,
    payload: error,
  };
};

// Add Category

export const addRestaurantSubCategoryRequest = (payload) => {
  return {
    type: POST_RESTAURANT_SUB_CATEGORY_REQUEST,
    payload,
  };
};

export const addRestaurantSubCategorySuccess = (data) => {
  return {
    type: POST_RESTAURANT_SUB_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const addRestaurantSubCategoryFailure = (error) => {
  return {
    type: POST_RESTAURANT_SUB_CATEGORY_FAILURE,
    payload: error,
  };
};

export const updateRestaurantSubCategoryRequest = (payload) => {
  return {
    type: PUT_RESTAURANT_SUB_CATEGORY_REQUEST,
    payload,
  };
};

export const updateRestaurantSubCategorySuccess = (data) => {
  return {
    type: PUT_RESTAURANT_SUB_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const updateRestaurantSubCategoryFailure = (error) => {
  return {
    type: PUT_RESTAURANT_SUB_CATEGORY_FAILURE,
    payload: error,
  };
};

export const deleteRestaurantSubCategoryRequest = (payload) => {
  return {
    type: DELETE_RESTAURANT_SUB_CATEGORY_REQUEST,
    payload,
  };
};

export const deleteRestaurantSubCategorySuccess = (data) => {
  return {
    type: DELETE_RESTAURANT_SUB_CATEGORY_SUCCESS,
    payload: data,
  };
};

export const deleteRestaurantSubCategoryFailure = (error) => {
  return {
    type: DELETE_RESTAURANT_SUB_CATEGORY_FAILURE,
    payload: error,
  };
};
